import { useEffect } from 'react';
import { Alert, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Balance from '../../components/Balance';
import BottomNavigationBar from '../../components/BottomNavigationBar';
import ShopItemCard from '../../components/ShopItemCard';
import UserPageHeader from '../../components/UserPageHeader';
import useShopItemsStore from '../../store/shopItems';
import useUserStore from '../../store/user';

export default function ShopPage() {
  const balance = useUserStore(state => state.balance);
  const { t } = useTranslation();

  const items = useShopItemsStore(state => state.items);
  const isLoading = useShopItemsStore(state => state.isLoading);
  const error = useShopItemsStore(state => state.error);
  const fetchShopItems = useShopItemsStore(state => state.fetchShopItems);

  useEffect(() => {
    fetchShopItems();
  }, [fetchShopItems]);

  return (
    <Container className="pt-3 pb-5">
      <Row>
        <Col xs={12}>
          <UserPageHeader />
          <Balance value={balance} />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col xs={12}>
          <h2 className="h3 fw-bold mb-3">{t('shop.title')}</h2>

          {isLoading && (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">{t('common.loading')}</span>
              </Spinner>
            </div>
          )}

          {error && (
            <Alert variant="danger" role="alert">
              {error}
            </Alert>
          )}

          {!isLoading && items.length === 0 && !error && (
            <p className="text-center text-white-50 mt-5 fs-4">
              {t('shop.noItems')}
            </p>
          )}

          {items.map(item => (
            <ShopItemCard key={item._id} itemId={item._id} />
          ))}
        </Col>
      </Row>
      <BottomNavigationBar />
    </Container>
  );
}
